import { MarqBrandEnumsCvassistantCvAssistantTabEnum } from '~/swagger/data-contracts';

export enum MarketplaceRouteEnum {
  Detection = 'detection',
  UnderReview = 'under-review',
  ReportSubmitted = 'report-submitted',
  SoftNotice = 'soft-notice',
  Removed = 'removed',
  Denied = 'denied',
  NotEnforceable = 'not-enforceable',
  Dismissed = 'dismissed',
  OnHold = 'on-hold',
  Archived = 'archived',
  ReviewNeeded = 'review-needed',
  TestPurchaseReviewing = 'tp-reviewing',
  TestPurchaseDelivery = 'tp-purchase-delivery',
  TestPurchaseCompleted = 'tp-completed',
  TestPurchaseCaseClosed = 'tp-case-closed',
}

export enum SocialMediaRouteEnum {
  Detection = 'detection',
  UnderReview = 'under-review',
  ReportSubmitted = 'report-submitted',
  SoftNotice = 'soft-notice',
  Removed = 'removed',
  Denied = 'denied',
  NotEnforceable = 'not-enforceable',
  Dismissed = 'dismissed',
  OnHold = 'on-hold',
  Archived = 'archived',
  ReviewNeeded = 'review-needed',
  TestPurchaseReviewing = 'tp-reviewing',
  TestPurchaseDelivery = 'tp-purchase-delivery',
  TestPurchaseCompleted = 'tp-completed',
  TestPurchaseCaseClosed = 'tp-case-closed',
}

export enum WebsiteContentRouteEnum {
  Detected = 'detected',
  Requested = 'requested',
  Reported = 'reported',
  Removed = 'removed',
  Denied = 'denied',
  Dismissed = 'dismissed',
  TestPurchaseReviewing = 'tp-reviewing',
  TestPurchaseDelivery = 'tp-purchase-delivery',
  TestPurchaseCompleted = 'tp-completed',
  TestPurchaseCaseClosed = 'tp-case-closed',
}

export type ConversationalAssistantRouteEnum = MarqBrandEnumsCvassistantCvAssistantTabEnum;

export enum SettingsRouteEnum {
  Account = 'account',
  Billing = 'billing',
  People = 'people',
  Credits = 'credits',
  Tag = 'tag',
}
